const dayTReducer = (state =[], {type, load}) => {
    switch (type) {
        case 'GET_DAILY': return [...state, ...load]
            
        default: return state
    }

}

export default dayTReducer